// src/extenders/navigation-handler.js
var Popover = class {
  constructor(trigger) {
    this.trigger = trigger;
    this.popoverId = trigger.getAttribute("data-popover-trigger");
    this.popover = document.querySelector(`#popover-${this.popoverId}`);
    this.popoverAside = document.querySelector(`#popover-aside-${this.popoverId}`);
    this.isMobile = window.matchMedia("(max-width: 1024px)").matches;
    this.currentPopover = this.isMobile ? this.popoverAside : this.popover;
    this.showPopover = this.showPopover.bind(this);
    this.hidePopover = this.hidePopover.bind(this);
    this.togglePopover = this.togglePopover.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.addEventListeners();
  }
  addEventListeners() {
    if (this.trigger && this.currentPopover) {
      if (this.isMobile) {
        this.trigger.addEventListener("click", this.togglePopover);
        document.addEventListener("click", (e) => {
          if (!this.trigger.contains(e.target) && !this.currentPopover.contains(e.target)) {
            this.hidePopover();
          }
        });
        const closeButton = this.currentPopover.querySelector(".close-aside");
        if (closeButton) {
          closeButton.addEventListener("click", this.hidePopover);
        }
      } else {
        this.trigger.addEventListener("mouseenter", this.showPopover);
        this.trigger.addEventListener("mouseleave", this.hidePopover);
        this.currentPopover.addEventListener("mouseenter", this.showPopover);
        this.currentPopover.addEventListener("mouseleave", this.hidePopover);
      }
    }
    window.addEventListener("resize", this.handleResize);
  }
  handleResize() {
    this.isMobile = window.matchMedia("(max-width: 1024px)").matches;
    this.currentPopover = this.isMobile ? this.popoverAside : this.popover;
    this.removeEventListeners();
    this.addEventListeners();
  }
  removeEventListeners() {
    if (this.trigger && this.currentPopover) {
      if (this.isMobile) {
        this.trigger.removeEventListener("click", this.togglePopover);
        const closeButton = this.currentPopover.querySelector(".close-aside");
        if (closeButton) {
          closeButton.removeEventListener("click", this.hidePopover);
        }
      } else {
        this.trigger.removeEventListener("mouseenter", this.showPopover);
        this.trigger.removeEventListener("mouseleave", this.hidePopover);
        this.currentPopover.removeEventListener("mouseenter", this.showPopover);
        this.currentPopover.removeEventListener("mouseleave", this.hidePopover);
      }
    }
  }
  showPopover() {
    if (this.currentPopover) {
      if (!this.isMobile) {
        this.currentPopover.classList.remove("hidden");
      }
      this.trigger.setAttribute("aria-expanded", "true");
      if (this.isMobile) {
        this.currentPopover.classList.add("popover-aside-show");
      }
    }
  }
  hidePopover() {
    if (this.currentPopover) {
      if (!this.isMobile) {
        this.currentPopover.classList.add("hidden");
      }
      this.trigger.setAttribute("aria-expanded", "false");
      if (this.isMobile) {
        this.currentPopover.classList.remove("popover-aside-show");
      }
    }
  }
  togglePopover() {
    if (this.currentPopover) {
      if (this.isMobile) {
        if (this.currentPopover.classList.contains("popover-aside-show")) {
          this.hidePopover();
        } else {
          this.showPopover();
        }
      } else {
        if (this.currentPopover.classList.contains("hidden")) {
          this.showPopover();
        } else {
          this.hidePopover();
        }
      }
    }
  }
};
document.addEventListener("DOMContentLoaded", () => {
  const triggers = document.querySelectorAll(".popover-trigger");
  triggers.forEach((trigger) => new Popover(trigger));
});
